import script from "./MobileLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./MobileLayout.vue?vue&type=script&setup=true&lang=js"

import "./MobileLayout.vue?vue&type=style&index=0&id=45ea200a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-45ea200a"]])

export default __exports__